export default __webpack_public_path__ + "static/icon-c0508be7cd187f6050a16020e8a78331.png";